import cx from 'classnames';
import type { ReactNode } from 'react';
import styles from './styles.module.css';

interface ItemProps {
  isAlone?: boolean;
  isWithOnlyOneOtherItem?: boolean;
  active?: boolean;
  children: NonNullable<ReactNode>;
}

function Item({ isAlone, active, children, isWithOnlyOneOtherItem }: ItemProps): ReactNode {
  return (
    <li
      className={cx(styles.Item, {
        [styles.ActiveItem]: active,
        [styles.AloneItem]: isAlone,
        [styles.OnlyWithOneOtherItem]: isWithOnlyOneOtherItem,
      })}
    >
      <span>{children}</span>
    </li>
  );
}

export interface StepsProps {
  vertical?: boolean;
  dots?: boolean;
  children: NonNullable<ReactNode>;
}

export function Steps({ vertical, dots, children }: StepsProps): ReactNode {
  return (
    <ul
      className={cx(styles.Items, {
        [styles.VerticalItems]: vertical,
        [styles.Dotted]: dots,
      })}
    >
      {children}
    </ul>
  );
}

Steps.Item = Item;
